import React from 'react'
import { qiniuUploadUrl, qiniuImageURLPrefix, qiniuVideoURLPrefix, getQiniuUploadToken } from '@/config/qiniu'
import * as qiniu from 'qiniu-js'
import axios from 'axios'
import $msg from '@/utils/message'

export class UploadInstance {
    public file: File | null = null
    public name: string = ''
    public sizeUnit: number = 0
    public filetype: number = 0
    public typename: string = ''
    public progress: number = 0
    public status: 'pending' | 'uploading' | 'error' | 'complete' = 'pending'
    public fileSrc: string = ''
    public uid: string = ''
    public proportion: string = ''
    public duration: number = 0
    constructor(props: { file: File }) {
        this.file = props.file
        this.status = 'pending'
        this.name = this.file.name.split('.')[0].slice(0, 14) + '.' // 文件名字
        this.sizeUnit = this.file.size
        this.filetype = this.checkFileType(this.file) // 1 图片， 2 视频
        this.typename = this.file.type && this.file.type.split('/')[1]
        this.fileSrc = '' // 图片
        this.uid = new Date().valueOf() + 'Up' + +Math.random() * 100
        this.proportion = '' // 图片大小
        this.duration = 0 // 视频文件大小
    }

    public onUpload(r: any) {
        this.progress = +r.total.percent.toFixed(2)
    }

    public onError(e: any) {
        this.status = 'error'
    }

    public onComplete(res: any) {
        this.status = 'complete'
        // 判断图片类型
        this.fileSrc = res.key

        if (this.filetype === 1) {
            // 获取图片信息 imageInfo
            axios.get(`${qiniuImageURLPrefix}${res.key}?imageInfo`).then((res1: any) => {
                // console.log(res)
                this.proportion = `${res1.data.width}x${res1.data.height}`
            })
        }

        if (this.filetype === 2) {
            axios.get(`${qiniuVideoURLPrefix}${res.key}?avinfo`).then((res2: any) => {
                this.duration = Math.ceil(+res2.data.format.duration)
            })
        }
    }

    //  返回文件类型 1 图片 2 视频
    private checkFileType(item: any) {
        let type = -1
        const videoList = ['mov', 'mp4']
        const imageList = ['png', 'jpg', 'jpeg']
        const name = item.name
        videoList.forEach(node => {
            const reg = new RegExp('.' + node + '$', 'i')
            if (reg.test(name)) {
                type = 2
            }
        })
        imageList.forEach(node => {
            const reg = new RegExp('.' + node + '$', 'i')
            if (reg.test(name)) {
                type = 1
            }
        })

        return type
    }
}

export interface IOnError {
    code: number
    isRequestError: boolean
    message: string
}

// tslint:disable-next-line:no-empty-interface
interface IProps {
    className?: string
    style?: React.CSSProperties
    onLoad?: (data: UploadInstance) => void // 文件上传
    onChange?: (data: UploadInstance) => void
    onSuccess?: (res: any, data: UploadInstance, list: string[]) => void
    onError?: (error: IOnError) => void
    images?: boolean
    camera?: boolean
    accept?: string
    multiple?: boolean
    maxCount?: number
}

interface IState {
    fileLists: any[]
    materialInfo: any
}
export default class SgUpload extends React.Component<IProps, IState> {
    private static nextInputId = 0
    private qiniuDomain: string = qiniuUploadUrl
    private qiniuToken1: string = ''
    private qiniuToken2: string = ''
    private observer: any = {}
    private inputRef: React.RefObject<HTMLInputElement>
    private inputId: string
    private Uploadprops: any = {
        action: qiniuUploadUrl,
        multiple: false,
    }
    private currentImageCount: number = 0
    public fileList: string[] = []

    private staticProps = {
        camera: false,
        images: false,
    }
    constructor(props: any) {
        super(props)
        this.state = {
            fileLists: [],
            materialInfo: {},
        }

        this.inputRef = React.createRef()
        this.inputId = `upload-image-${++SgUpload.nextInputId}`
    }

    public render() {
        return (
            <div className={this.props.className} style={{ position: 'relative', cursor: 'pointer' }}>
                {this.props.images ? (
                    <input
                        ref={this.inputRef}
                        type="file"
                        id={this.inputId}
                        multiple={this.props.multiple}
                        accept={this.props.accept || 'image/*'}
                        onChange={file1 => this.loopUpload(file1)}
                        style={{
                            opacity: 0,
                            background: 'blue',
                            position: 'fixed',
                            top: '-100px',
                            left: '-100px',
                            cursor: 'pointer',
                            ...this.props.style,
                        }}
                    />
                ) : (
                    <input
                        ref={this.inputRef}
                        type="file"
                        id={this.inputId}
                        multiple={this.props.multiple}
                        accept={this.props.accept || 'video/*,image/*'}
                        onChange={file1 => this.loopUpload(file1)}
                        style={{
                            opacity: 0,
                            background: 'blue',
                            position: 'fixed',
                            top: '-100px',
                            left: '-100px',
                            cursor: 'pointer',
                            ...this.props.style,
                        }}
                    />
                )}
                <label
                    htmlFor={this.inputId}
                    onClickCapture={event => {
                        const button = (event.target as HTMLElement).closest('button')
                        if (button) {
                            event.preventDefault()
                            if (!button.disabled && this.inputRef.current) {
                                this.inputRef.current.click()
                            }
                        }
                    }}
                >
                    {this.props.children}
                </label>
            </div>
        )
    }

    public loopUpload(files: React.ChangeEvent<HTMLInputElement>) {
        if (!files.target.files!.length) return
        const maxLimit = this.props.maxCount || 9
        if (files.target.files!.length > maxLimit) return $msg('error', `当前最多上传${maxLimit}张图片`)
        this.currentImageCount = files.target.files!.length
        for (let i = 0; i < files.target.files!.length; i++) {
            this.qiniuUpload(files.target.files![i])
        }
    }

    public componentWillUnmount() {
        this.fileList = []
    }

    // 自定义上传方式
    private qiniuUpload(file: any) {
        const fileType = file.type.includes('image') ? 'img' : 'video'
        // 检查大小
        const is100M = file.size / 1024 / 1024 < 100
        // 限制大小改成10
        const is10M = file.size / 1024 / 1024 < 10
        if (fileType === 'img' && !is10M) {
            if (this.inputRef.current) {
                this.inputRef.current.value = ''
            }
            $msg('error', '图片大小不能超过10M')

            return
        } else if (fileType === 'video' && !is100M) {
            if (this.inputRef.current) {
                this.inputRef.current.value = ''
            }
            $msg('error', '视频大小不能超过100M，建议时长在5分钟以内')

            return
        } else if (!this.isAcceptedFile(file.name)) {
            if (this.inputRef.current) {
                this.inputRef.current.value = ''
            }
            $msg('error', '不支持上传该格式图片')

            return
        }
        const uploadInstance = new UploadInstance({
            file: file,
        })
        const observer = {
            next: (res: any) => {
                uploadInstance.onUpload(res)
                this.props.onChange && this.props.onChange(uploadInstance)
            },
            error: (err: any) => {
                if (this.inputRef.current) {
                    this.inputRef.current.value = ''
                }
                uploadInstance.onError(err)
                this.props.onError && this.props.onError(err)
            },
            complete: (res: any) => {
                if (this.inputRef.current) {
                    this.inputRef.current.value = ''
                } // 支持同一张照片上传
                uploadInstance.onComplete(res)
                this.fileList.push(res.key)
                if (this.fileList.length >= this.currentImageCount) {
                    this.props.onSuccess && this.props.onSuccess(res, uploadInstance, this.fileList)
                    this.fileList = []
                }
            },
        }
        this.props.onLoad && this.props.onLoad(uploadInstance)

        const putExtra = {
            fname: file.name,
            params: {},
            mimeType: ['video/mov', 'video/quicktime', 'video/mp4', 'image/png', 'image/jpg', 'image/jpeg'],
        }
        const config: any = {
            useCdnDomain: true,
            region: null,
            checkByMD5: true,
            forceDirect: true,
        }

        if (file.type.includes('image')) {
            this.getQiniuToken(1, () => {
                // @ts-ignore
                const observable = qiniu.upload(file, file.key, this.qiniuToken1, putExtra, config)
                observable.subscribe(observer)
            })
        }
        if (file.type.includes('video')) {
            this.getQiniuToken(2, () => {
                // @ts-ignore
                const observable = qiniu.upload(file, file.key, this.qiniuToken2, putExtra, config)
                observable.subscribe(observer)
            })
        }
    }

    //  是否处于接受的文件格式类型内
    private isAcceptedFile(fileName: string) {
        //  注释的视频类型均为七牛不支持类型
        const videoList = ['mov', 'mp4']
        const imageList = ['png', 'jpg', 'jpeg']
        let flag = false
        videoList.forEach(node => {
            const reg = new RegExp('.' + node + '$', 'i')
            if (reg.test(fileName)) {
                flag = true
            }
        })
        imageList.forEach(node => {
            const reg = new RegExp('.' + node + '$', 'i')
            if (reg.test(fileName)) {
                flag = true
            }
        })

        return flag
    }

    // 获取七牛的token
    private getQiniuToken(type: number, cb: () => void) {
        getQiniuUploadToken(type)
            .then(data => {
                if (!data || !data.token) throw new Error('获取上传凭证失败')
                if (type === 1) {
                    this.qiniuToken1 = data.token
                } else {
                    this.qiniuToken2 = data.token
                }
                cb && cb()
            })
            .catch(error => {
                if (this.inputRef.current) this.inputRef.current.value = ''
                if (this.props.onError) {
                    this.props.onError({ code: 0, isRequestError: true, message: error.message || '获取上传凭证失败' })
                } else {
                    $msg('error', error.message || '获取上传凭证失败')
                }
            })
    }
}
